import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Accounts from './pages/Accounts';
import PhoneNumbers from './pages/PhoneNumbers';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/accounts" element={<Accounts />} />
          <Route path="/phone-numbers" element={<PhoneNumbers />} />
        </Routes>
      </Layout>
    </div>
  );
}

export default App;